import { FC } from "react";

type LimitFunctionTableRowHeadProps = {
  title: string;
  notes?: string;
};

const LimitFunctionTableRowHead: FC<LimitFunctionTableRowHeadProps> = ({
  title,
  notes,
}) => {
  return (
    <th className="p-16 text-left text-sm laptop:p-24 laptop:text-base">
      <p>{title}</p>
      {notes && <small>{notes}</small>}
    </th>
  );
};
export default LimitFunctionTableRowHead;
